import { createContext, useContext, useMemo, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("de");

  const toggle = useCallback(() => {
    setLang((prev) => (prev === "de" ? "en" : "de"));
  }, []);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      toggle,
      t: translations[lang],
    }),
    [lang, toggle]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used inside LanguageProvider");
  return ctx;
}
